import React, { useEffect, useState, useRef } from 'react';
import './Footer.css'
import { Link as Anchor } from 'react-router-dom';
import logo from '../../images/logo.png'
import baseURL from '../url';
import TikTokIcon from '../TikTokIcon/TikTokIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faMapMarkerAlt, faIdCard, faUserPlus, faCalendarAlt, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import useSiteConfig from '../useSiteConfig';

export default function Footer() {
    const { logo: siteLogo, color_footer, footer_bg_image, footer_bg_opacity } = useSiteConfig();
    const [categorias, setCategorias] = useState([]);
    const [contactos, setContactos] = useState([]);
    const [quienesSomos, setQuienesSomos] = useState([]);

    useEffect(() => {
        cargarProductos();
    }, []);

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const categoriasMap = new Map();
                data.productos.forEach(producto => {
                    const categoria = producto.categoria;
                    if (categoriasMap.has(categoria)) {
                        categoriasMap.get(categoria).push(producto);
                    } else {
                        categoriasMap.set(categoria, [producto]);
                    }
                });
                const categoriasArray = Array.from(categoriasMap, ([categoria, productos]) => ({ categoria, productos }));
                setCategorias(categoriasArray?.slice(0, 3));
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    useEffect(() => {
        cargarContacto();
        cargarQuienesSomos();
    }, []);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const lista = data.contacto || [];
                setContactos(lista[0] || {});
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const cargarQuienesSomos = () => {
        fetch(`${baseURL}/quienesSomosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setQuienesSomos(data.quienesSomos || []);
            })
            .catch(error => console.error('Error al cargar Quiénes Somos:', error));
    };

    const telefonoLimpio = (contactos.telefono || '').replace(/\D/g, '');

    return (
        <div
            className='FooterContain'
            style={{
                backgroundColor: color_footer || undefined,
                '--footer-bg-image': footer_bg_image ? `url("${footer_bg_image}")` : 'none',
                '--footer-bg-opacity': footer_bg_opacity !== undefined ? footer_bg_opacity : '0.70'
            }}
        >
            <div className='footerText'>
                <div className='footerLogoBrand'>
                    <Anchor to='/' className='footerLogoLink'>
                        <img src={siteLogo || logo} alt="logo" onError={(e) => { e.target.src = logo; }} />
                    </Anchor>
                    <h2>
                        {contactos.nombre}
                    </h2>
                </div>

                {/* Enlace hacia la nueva página con el nombre registrado en Quiénes Somos */}
                {quienesSomos && quienesSomos.length > 0 && (
                    <div className='footerQuienesSomosWrapper'>
                        {quienesSomos.map((qs) => (
                            <Anchor
                                key={qs.idQuienesSomos}
                                to="/quienes-somos"
                                className='btnFooterQuienesSomos'
                                title={`Conoce más sobre ${qs.titulo}`}
                            >
                                <FontAwesomeIcon icon={faInfoCircle} /> {qs.titulo}
                            </Anchor>
                        ))}
                    </div>
                )}

                <div className='socials'>
                    {contactos.instagram && <Anchor to={contactos.instagram} target="_blank" rel="noopener noreferrer"><i className='fa fa-instagram'></i></Anchor>}
                    {contactos.telefono && <Anchor to={`tel:${contactos.telefono}`} target="_blank" rel="noopener noreferrer"><i className='fa fa-whatsapp'></i></Anchor>}
                    {contactos.facebook && <Anchor to={contactos.facebook} target="_blank" rel="noopener noreferrer"><i className='fa fa-facebook'></i></Anchor>}
                    {contactos.tiktok && (
                        <Anchor to={contactos.tiktok.startsWith('http') ? contactos.tiktok : `https://www.tiktok.com/@${contactos.tiktok.replace(/^@/, '')}`} target="_blank" rel="noopener noreferrer" title="TikTok">
                            <TikTokIcon size={16} />
                        </Anchor>
                    )}
                    <Anchor to={`/dashboard`} >
                        <FontAwesomeIcon icon={faUser} />
                    </Anchor>
                </div>
            </div>

            <div className='footerText'>
                <h3>Contacto</h3>
                <Anchor to={`mailto:${contactos.email}`} target="_blank" rel="noopener noreferrer">{contactos.email}</Anchor>
                <Anchor to={`tel:${contactos.telefono}`} target="_blank" rel="noopener noreferrer">{contactos.telefono}</Anchor>
                <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(contactos.direccion || '')}`} target="_blank" rel="noopener noreferrer">{contactos.direccion}</Anchor>
            </div>

            {/* Columna 3: DXN en el Perú */}
            <div className='footerText'>
                <h3>DXN en el Perú</h3>
                <Anchor to="/centros" className="footer-item-link" title="Ver lista de centros oficial">
                    <FontAwesomeIcon icon={faMapMarkerAlt} className="footer-icon-accent" /> Lista de Centros
                </Anchor>
                <Anchor to="/verificar-afiliado" className="footer-item-link" title="Consultar si tu DNI está afiliado">
                    <FontAwesomeIcon icon={faIdCard} className="footer-icon-accent" /> Ver Si estoy Afiliado
                </Anchor>
                <a
                    href="https://eworld.dxn2u.com/s/accreg/es419/011321616"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-item-link highlight-afiliate"
                    title="Afiliarse a DXN"
                >
                    <FontAwesomeIcon icon={faUserPlus} className="footer-icon-accent" /> ¡Afíliate ahora a DXN!
                </a>
            </div>
        </div>
    )
}
